//批量导入图片模块
let file = require.context('@/assets/img', true, /^./);//获取img文件夹下所有图片
const modules = file.keys().reduce((item, path) => {//循环处理
    const name = path.replace(/^\.\/(.*)\.\w+$/, '$1');//匹配模块名字
    const value = file(path);//获取模块路径
    item[name] = value;
    return item;
}, {});

export default modules;